let token = window.localStorage.getItem("token")
import request from "../utils/request.js"
import requestExport from "../utils/request2.js"
import {
  uploadFilesBaseUrl,baseURL
} from "./baseURL";
//退休一线报道新增
function insertPartyReport(tanchuadd) {

  return request({
    url: "/djyl/admin/partyReport/info/insert",
    method: "POST",
    data: tanchuadd
  });
}
//退休一线报道编辑
function updatePartyReport(tanchuadd) {
  // let params = JSON.stringify(tanchuadd);
  // let fd = new FormData()
  // fd.append("token", token)
  // fd.append("params", params)
  return request({
    url: "/djyl/admin/partyReport/info/update",
    method: "POST",
    data: tanchuadd
  });
}



//退休一线报道列表查询
function findPartyReport(params) {
  return request({
    url: "/djyl/admin/partyReport/info/list",
    method: "POST",
    data: params
  });
}
//退休一线报道列表查询
function findPartyReportById(id) {
  return request({
    url: "/djyl/admin/partyReport/info/findById",
    method: "POST",
    data: {
      id: id
    }
  });
}
//退休一线报道删除
function deletePartyReport(id) {
  // let fd = new FormData()
  // fd.append("token", token)
  // fd.append("id", id)

  return request({
    url: "/djyl/admin/partyReport/info/delete",
    method: "POST",
    data: {
      id: id
    }
  });
}

//退休一线报道审核
function auditPartyReport(tanchuadd) {
  // let params = JSON.stringify(tanchuadd);
  // let fd = new FormData()
  // fd.append("token", token)
  // fd.append("params", params)
  return request({
    url: "/djyl/admin/partyReport/info/audit",
    method: "POST",
    data: tanchuadd
  });
}
//退休一线报到统计人echarts
function findPartyReportStatistics(params) {
  // let fd = new FormData()
  // fd.append("token", token)
  return request({
    url: "/djyl/admin/partyReport/info/findPartyReportStatistics",
    method: "POST",
    data: params
  });
}

function findPartyReportMothStatistics(params) {
  return request({
    url: "/djyl/admin/partyReport/info/findPartyReportMothStatistics",
    method: "POST",
    data: params
  });
}


//志愿服务新增
function insertActivity(tanchuadd) {
  let params = JSON.stringify(tanchuadd);
  let fd = new FormData()
  fd.append("token", token)
  fd.append("params", params)
  return request({
    url: "/djyl/admin/activity/info/insertActivity",
    method: "POST",
    data: fd
  });
}

//志愿服务列表查询
function findActivity({
                        pageNo,
                        pageSize,
                        activityName,
                        activityTime,
                        auditStatus,
                        activityStatus
                      }) {
  let fd = new FormData()
  fd.append("token", token)
  fd.append("pageNo", pageNo)
  fd.append("pageSize", pageSize)
  if (activityName != undefined) {
    fd.append("activityName", activityName)
  }
  if (auditStatus != undefined) {
    fd.append("auditStatus", auditStatus)
  }
  if (activityTime != undefined) {

    fd.append("activityTime", activityTime)
  }
  if (activityStatus != undefined) {

    fd.append("activityStatus", activityStatus)
  }
  return request({
    url: "/djyl/admin/activity/info/findActivity",
    method: "POST",
    data: fd
  });
}

//退休一线报道列表查询
function findActivityById(id) {
  let fd = new FormData()
  fd.append("token", token)
  fd.append("id", id)
  return request({
    url: "/djyl/admin/activity/info/findActivityById",
    method: "POST",
    data: fd
  });
}


//志愿服务编辑
function updateActivity(tanchuadd) {
  let params = JSON.stringify(tanchuadd);
  let fd = new FormData()
  fd.append("token", token)
  fd.append("params", params)
  return request({
    url: "/djyl/admin/activity/info/updateActivity",
    method: "POST",
    data: fd
  });
}
//志愿服务审核
function auditActivity(tanchuadd) {
  let params = JSON.stringify(tanchuadd);
  let fd = new FormData()
  fd.append("token", token)
  fd.append("params", params)
  return request({
    url: "/djyl/admin/activity/info/auditActivity",
    method: "POST",
    data: fd
  });
}
//志愿服务删除
function deleteActivity(id) {
  let fd = new FormData()
  fd.append("token", token)
  fd.append("id", id)

  return request({
    url: "/djyl/admin/activity/info/deleteActivity",
    method: "POST",
    data: fd
  });
}
//志愿服务终止
function stopActivity(id) {
  let fd = new FormData()
  fd.append("token", token)
  fd.append("id", id)

  return request({
    url: "/djyl/admin/activity/info/stopActivity",
    method: "POST",
    data: fd
  });
}
//在线学习学习资源库视频上传
function uploadOnlineStudyPhoto(file) {
  console.log(file)
  let fd = new FormData()
  fd.append("token", token)
  fd.append('file', file)
  return request({
    url: "/djyl/controller/uploadVotePic/info/uploadOnlineStudyPhoto",
    method: "POST",
    data: fd,
    baseURL: uploadFilesBaseUrl
  });
}
//视频
function uploadOnlineStudyVideo(file) {
  console.log(file)
  let fd = new FormData()
  fd.append("token", token)
  fd.append('file', file)
  return request({
    url: "/jjyl/controller/uploadController/info/uploadVideo",
    method: "POST",
    data: fd,
    baseURL: baseURL
  });
}
//音频
function uploadOnlineStudyAudio(file) {
  console.log(file)
  let fd = new FormData()
  fd.append("token", token)
  fd.append('file', file)
  return request({
    url: "/jjyl/controller/uploadController/info/uploadRecord",
    method: "POST",
    data: fd,
    baseURL: baseURL
  });
}
//新增在线学习
function insertOnlineStudy(tanchuadd) {
  // let params = JSON.stringify(tanchuadd);
  // let fd = new FormData()
  // fd.append("token", token)
  // fd.append("params", params)
  return request({
    url: "/djyl/admin/learnResourceBase/info/insert",
    method: "POST",
    data: tanchuadd
  });
}

//在线学习列表查询
//在线学习列表查询
function findOnlineStudy(tanchuadd) {
  console.log(tanchuadd)
  return request({
    url: "/djyl/admin/learnResourceBase/info/list",
    method: "POST",
    data: tanchuadd
  });
}
//在线学习关键词查询
function findKeywords(tanchuadd) {
  return request({
    url: "/djyl/admin/learnResourceBase/info/keywordSatistics",
    method: "POST",
    data: tanchuadd
  })
}
//在线学习删除
function deleteOnlineStudy(id) {
  return request({
    url: "/djyl/admin/learnResourceBase/info/delete",
    method: "POST",
    data: id
  });
}
//在线学习查看按照id
function findOnlineStudyById(id) {
  // let fd = new FormData()
  // fd.append("token", token)
  // fd.append("id", id)
  return request({
    url: "/djyl/admin/learnResourceBase/info/findById",
    method: "POST",
    data: id
  });
}
//编辑在线学习
function updateOnlineStudy(tanchuadd) {
  return request({
    url: "/djyl/admin/learnResourceBase/info/update",
    method: "POST",
    data: tanchuadd
  });
}
//在线学习审核
function auditOnlineStudy(tanchuadd) {
  return request({
    url: "/djyl/admin/learnResourceBase/info/audit",
    method: "POST",
    data: tanchuadd
  });
}


//在线学习发布
function stopOnlineStudy(id) {
  let fd = new FormData()
  fd.append("token", token)
  fd.append("id", id)
  return request({
    url: "/djyl/admin/onlineStudy/info/startOnlineStudy",
    method: "POST",
    data: fd
  });
}
//资源类别统计表
function findResourceTypeStatistic(tanchuadd) {
  return request({
    url: "/djyl/admin/learnResourceBase/info/resourceCategorySatistics",
    method: "POST",
    data: tanchuadd
  });
}
//在线学习视频排名
function findOnlineStudyRanking(tanchuadd) {
  // let fd = new FormData()
  // fd.append("token", token)
  return request({
    url: "/djyl/admin/learnResourceBase/info/learnerSatistics",
    method: "POST",
    data: tanchuadd
  });
}

//题库管理上传音频
function uploadQuestionBankPhoto(file) {
  let fd = new FormData()
  fd.append("token", token)
  fd.append('file', file)
  return request({
    url: "/controller/uploadVotePic/info/uploadQuestionBankPhoto",
    method: "POST",
    data: fd
  });
}

//题库管理 单选题模板下载
export const templateDownload = (params) => {
  return requestExport({
    url: "/djyl/admin/questionBank/info/templateDownload",
    method: "POST",
    data: params,
    responseType: 'blob'
  });
}

export const importQuestionBankUrl = request.defaults.baseURL + "/djyl/admin/questionBank/info/importQuestionBank";


//题库管理 题目导入
export const importQuestionBank = (file) => {
  let formData = new FormData();
  formData.append("file", file);
  return request({
    url: "/djyl/admin/questionBank/info/importQuestionBank",
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data: formData
  });
}

// 题库管理 导出
export const downloadQuestionBank = (params) => {
  return requestExport({
    url: "/djyl/admin/questionBank/info/downloadQuestionBank",
    method: "POST",
    data: params,
    responseType: 'blob'
  });
}


//在线考试题库管理新增
function insertQuestionBank(tanchuadd) {
  return request({
    url: "/djyl/admin/questionBank/info/insertQuestionBank",
    method: "POST",
    data: tanchuadd
  });
}

//查看题库列表
function findQuestionBank(params) {
  return request({
    url: "/djyl/admin/questionBank/info/findQuestionBank",
    method: "POST",
    data: params
  });
}


//题库灌流查看按照id
function findQuestionBankById(id) {

  return request({
    url: "/djyl/admin/questionBank/info/findQuestionBankById",
    method: "POST",
    data: {
      id: id
    }
  });
}

//学员统计列表查询
function findOnlineStudyStatistic(params) {
  return request({
    url: "/djyl/admin/onlineStudy/info/findOnlineStudyStatistic",
    method: "POST",
    data: params
  });
}

//优秀学员统计
function findStudyPersonStatistic() {
  return request({
    url: "/djyl/admin/onlineStudy/info/findStudyPersonStatistic",
    method: "POST",
    data: {}
  });
}
//学员统计年龄分布
function findStudyAgeStatistic() {
  return request({
    url: "/djyl/admin/onlineStudy/info/findStudyAgeStatistic",
    method: "POST",
    data: {}
  });
}
// 近7日学习时长情况
export const findLastSevenStatistic = () => {
  return request({
    url: "/djyl/admin/onlineStudy/info/findLastSevenStatistic",
    method: "POST",
    data: {}
  });
}

// 学员统计 导出
export const downloadOnlineStudy = (params) => {
  return requestExport({
    url: "/djyl/admin/onlineStudy/info/downloadOnlineStudy",
    method: "POST",
    data: params,
    responseType: 'blob'
  });
}

//题库管理 编辑按照
function updateQuestionBank(tanchuadd) {
  return request({
    url: "/djyl/admin/questionBank/info/updateQuestionBank",
    method: "POST",
    data: tanchuadd
  });
}

//审核单选题

function auditQuestionBank(tanchuadd) {
  let params = JSON.stringify(tanchuadd);
  let fd = new FormData()
  fd.append("token", token)
  fd.append("params", params)
  return request({
    url: "/djyl/admin/questionBank/info/auditQuestionBank",
    method: "POST",
    data: fd
  });
}
//类型统计题库数量
function findTopicTypeStatistic() {
  return request({
    url: "/djyl/admin/questionBank/info/findTopicTypeStatistic",
    method: "POST",
    data: {}
  });
}
//考点统计
function findKnowledgeStatistic() {
  return request({
    url: "/djyl/admin/questionBank/info/findKnowledgeStatistic",
    method: "POST",
    data: {}
  });
}
//题目难度系数分析
function findCoefficientStatistic() {
  return request({
    url: "/djyl/admin/questionBank/info/findCoefficientStatistic",
    method: "POST",
    data: {}
  });
}

//题库管理删除
function deleteQuestionBank(id) {
  return request({
    url: "/djyl/admin/questionBank/info/deleteQuestionBank",
    method: "POST",
    data: {
      id: id
    }
  });
}
//随机组卷选择考试人员
function chooseTestPerson({
                            gridCode,
                            name,
                            idNumber
                          }) {

  return request({
    url: "/djyl/admin/testPaper/info/chooseTestPerson",
    method: "POST",
    data: {
      gridCode: gridCode,
      name: name,
      idNumber: idNumber,
    }
  });
}

//随机组卷新增
function insertTestPaper(tanchuadd) {
  return request({
    url: "/djyl/admin/testPaper/info/insertTestPaper",
    method: "POST",
    data: tanchuadd
  });
}


//人工组卷抽题
function findQuestion({
                        topicType,
                        score,
                        knowledge,
                        number
                      }) {
  let fd = new FormData()
  fd.append("token", token)
  if (topicType != undefined) {
    fd.append("topicType", topicType)
  }
  if (score != undefined) {
    fd.append("score", score)
  }
  if (knowledge != undefined) {
    fd.append("knowledge", knowledge)
  }
  if (number != undefined) {
    fd.append("number", number)
  }
  return request({
    url: "/djyl/admin/testPaper/info/findQuestion",
    method: "POST",
    data: fd
  });
}


// 获取题库
export const testPaperFindQuestion = (params) => {
  return request({
    url: "/djyl/admin/testPaper/info/findQuestion",
    method: "POST",
    data: params
  });
}

//试卷管理列表
function findTestPaper(params) {
  return request({
    url: "/djyl/admin/testPaper/info/findTestPaper",
    method: "POST",
    data: params
  });
}


//查看试卷详情信息
function findTestPaperById(id) {

  return request({
    url: "/djyl/admin/testPaper/info/findTestPaperById",
    method: "POST",
    data: {
      id: id
    }
  });
}
//发布试卷
function publishedPapers(tanchuadd) {
  return request({
    url: "/djyl/admin/testPaper/info/publishedPapers",
    method: "POST",
    data: tanchuadd
  });
}

//删除
function deleteTestPaper(id) {
  return request({
    url: "/djyl/admin/testPaper/info/deleteTestPaper",
    method: "POST",
    data: {
      id: id
    }
  });

}


//作废试卷
function invalidTest(tanchuadd) {
  let params = JSON.stringify(tanchuadd);
  let fd = new FormData()
  fd.append("token", token)
  fd.append("params", params)
  return request({
    url: "/djyl/admin/testPaper/info/invalidTest",
    method: "POST",
    data: fd
  });
}
//结束考试
function endTest(tanchuadd) {
  return request({
    url: "/djyl/admin/testPaper/info/endTest",
    method: "POST",
    data: tanchuadd
  });
}

function findTestPaperByIds(id) {
  return request({
    url: "/djyl/admin/testPaper/info/findTestPaperByIds",
    method: "POST",
    data: {
      id: id
    }
  });

}


//修改试卷
function updateTestPaper(tanchuadd) {
  return request({
    url: "/djyl/admin/testPaper/info/updateTestPaper",
    method: "POST",
    data: tanchuadd
  });
}

//审核
function auditTestPaper(tanchuadd) {
  return request({
    url: "/djyl/admin/testPaper/info/auditTestPaper",
    method: "POST",
    data: tanchuadd
  });
}


//统计速记组卷人工组卷
function findGroupWayStatistics() {

  return request({
    url: "/djyl/admin/testPaper/info/findGroupWayStatistics",
    method: "POST",
    data: {}
  });
}
//五年统计
function findTestNumberStatistics() {
  return request({
    url: "/djyl/admin/testPaper/info/findTestNumberStatistics",
    method: "POST",
    data: {}
  });
}

//成绩管理查看列表信息
function findScore(params) {
  return request({
    url: "/djyl/admin/score/info/findScore",
    method: "POST",
    data: params
  });
}

//成绩管理查看列表信息
function findScorePage(params) {
  return request({
    url: "/djyl/admin/score/info/findScorePage",
    method: "POST",
    data: params
  });
}

//查看成绩详情
function findScoreById(params) {
  return request({
    url: "/djyl/admin/score/info/findScoreById",
    method: "POST",
    data: params
  });

}

//通过率排名
function findPassTestStatistics(params) {
  return request({
    url: "/djyl/admin/score/info/findPassTestStatistics",
    method: "POST",
    data: params
  });

}
//近五年参考人数统计
function findTestPersonStatistics() {
  return request({
    url: "/djyl/admin/score/info/findTestPersonStatistics",
    method: "POST",
    data: {}
  });
}
//组织参考人数统计
function findTestOrgStatistics() {
  return request({
    url: "/djyl/admin/score/info/findTestOrgStatistics",
    method: "POST",
    data: {}
  });
}

//考生成绩
function findPartyScore({
                          name
                        }) {
  let fd = new FormData()
  fd.append("token", token)
  if (name != undefined) {
    fd.append("name", name)
  }
  return request({
    url: "/djyl/admin/partyScore/info/findPartyScore",
    method: "POST",
    data: fd
  });


}
//近五年通过率
function findPassRateStatistics() {
  let fd = new FormData()
  fd.append("token", token)
  return request({
    url: "/djyl/admin/partyScore/info/findPassRateStatistics",
    method: "POST",
    data: fd
  });
}
//组织平均分
function findOrgAverageStatistics() {
  let fd = new FormData()
  fd.append("token", token)
  return request({
    url: "/djyl/admin/partyScore/info/findOrgAverageStatistics",
    method: "POST",
    data: fd
  });
}
//优秀学生
function findGoodPartyStatistics() {
  let fd = new FormData()
  fd.append("token", token)
  return request({
    url: "/djyl/admin/partyScore/info/findGoodPartyStatistics",
    method: "POST",
    data: fd
  });
}

//党建积分列表查询
function findPartyIntegral({
                             pageNo,
                             pageSize,
                             name,
                             gridCode,
                             integral
                           }) {
  let fd = new FormData()
  fd.append("token", token)
  fd.append("pageNo", pageNo)
  fd.append("pageSize", pageSize)
  if (name != undefined) {
    fd.append("name", name)
  }
  if (gridCode != undefined) {
    fd.append("gridCode", gridCode)
  }
  if (integral != undefined) {
    fd.append("integral", integral)
  }

  return request({
    url: "/djyl/admin/partyIntegral/info/findPartyIntegral",
    method: "POST",
    data: fd
  });
}

//各社区得分情况
function findPartyIntegralOrg() {
  let fd = new FormData()
  fd.append("token", token)
  return request({
    url: "/djyl/admin/partyIntegral/info/findPartyIntegralOrg",
    method: "POST",
    data: fd
  });
}
//党员积分排行TOP5
function findPartyIntegralRank() {
  let fd = new FormData()
  fd.append("token", token)
  return request({
    url: "/djyl/admin/partyIntegral/info/findPartyIntegralRank",
    method: "POST",
    data: fd
  });
}
//积分来源
function findPartyIntegralSource(moth) {
  let fd = new FormData()
  if (moth != undefined && moth != null) {
    fd.append("moth", moth)
  }
  fd.append("token", token)
  return request({
    url: "/djyl/admin/partyIntegral/info/findPartyIntegralSource",
    method: "POST",
    data: fd
  });
}

//组织发展新增组织信息
function insertPartyOrganization(tanchuadd) {
  // let params = JSON.stringify(tanchuadd);
  // let fd = new FormData()
  // fd.append("token", token)
  // fd.append("params", params)
  return request({
    url: "/djyl/admin/partyOrganization/info/insert",
    method: "POST",
    data: tanchuadd
  });
}

//组织发展列表查询
function findPartyOrganization(params) {
  // let fd = new FormData()
  // fd.append("token", token)
  // fd.append("pageNo", pageNo)
  // fd.append("pageSize", pageSize)
  // if (applyName != undefined) {
  //     fd.append("applyName", applyName)
  // }
  // if (partyOrgId != undefined) {
  //     fd.append("partyOrgId", partyOrgId)
  // }
  // if (development != undefined) {
  //     fd.append("development", development)
  // }

  return request({
    url: "/djyl/admin/partyOrganization/info/list",
    method: "POST",
    data: params
  });
}

//党组织发展详情信息
function findPartyOrganizationById(id) {
  return request({
    url: "/djyl/admin/partyOrganization/info/findById",
    method: "POST",
    data: id
  });

}
//组织发展申请入党
function applyJoinParty(tanchuadd) {
  return request({
    url: "/djyl/admin/partyOrganization/info/applyJoinParty",
    method: "POST",
    data: tanchuadd
  });
}
//确定入党积极分子
function activistsParty(tanchuadd) {
  return request({
    url: "/djyl/admin/partyOrganization/info/recommendParty",
    method: "POST",
    data: tanchuadd
  });
}
//确定发展对象
function developParty(tanchuadd) {
  let params = JSON.stringify(tanchuadd);
  let fd = new FormData()
  fd.append("token", token)
  fd.append("params", params)
  return request({
    url: "/djyl/admin/partyOrganization/info/developParty",
    method: "POST",
    data: fd
  });
}
//接收预备党员
function prepareParty(tanchuadd) {
  let params = JSON.stringify(tanchuadd);
  let fd = new FormData()
  fd.append("token", token)
  fd.append("params", params)
  return request({
    url: "/djyl/admin/partyOrganization/info/prepareParty",
    method: "POST",
    data: fd
  });
}
//预备党员转正
function positiveParty(tanchuadd) {
  let params = JSON.stringify(tanchuadd);
  let fd = new FormData()
  fd.append("token", token)
  fd.append("params", params)
  return request({
    url: "/djyl/admin/partyOrganization/info/positiveParty",
    method: "POST",
    data: fd
  });
}
//组织发展概览
function findPartyOrganizationNumber() {
  return request({
    url: "/djyl/admin/partyOrganization/info/findPartyOrganizationNumber",
    method: "POST",
    data: {
      partyOrganization: {}
    }
  });
}
//组织发展概览
function findPartyOrganizationDevelop() {
  return request({
    url: "/djyl/admin/partyOrganization/info/findPartyOrganizationDevelop",
    method: "POST",
    data: {
      partyOrganization: {}
    }
  });
}

function findPartyOrganizationStructure() {
  return request({
    url: "/djyl/admin/partyOrganization/info/findPartyOrganizationStructure",
    method: "POST",
    data: {
      partyOrganization: {}
    }
  });
}


//党组织发展详情信息
function findActivitySignUpById(id) {
  let fd = new FormData()
  // fd.append("token", token)
  fd.append("activityId", id)
  return request({
    url: "/djyl/admin/activity/info/findActivitySignUpById",
    method: "POST",
    data: fd
  });

}

//组织发展列表查询
function findActivitySignUp({
                              pageNo,
                              pageSize,
                              activityId,
                              specialty
                            }) {
  let fd = new FormData()
  // fd.append("token", token)
  fd.append("pageNo", pageNo)
  fd.append("pageSize", pageSize)
  if (activityId != undefined) {
    fd.append("activityId", activityId)
  }
  if (specialty != undefined) {
    fd.append("specialty", specialty)
  }
  return request({
    url: "/djyl/admin/activity/info/findActivitySignUp",
    method: "POST",
    data: fd
  });
}
//组织发展列表查询
function auditSignUp({
                       activityId,
                       partyId
                     }) {
  let fd = new FormData()
  fd.append("token", token)
  fd.append("activityId", activityId)
  fd.append("partyId", partyId)

  return request({
    url: "/djyl/admin/activity/info/auditSignUp",
    method: "POST",
    data: fd
  });
}
//批量审核
function batchAuditSignUp({
                            activityId,
                            partyId
                          }) {
  let fd = new FormData()
  fd.append("token", token)
  fd.append("activityId", activityId)
  fd.append("partyId", partyId)

  return request({
    url: "/djyl/admin/activity/info/batchAuditSignUp",
    method: "POST",
    data: fd
  });
}
//活动总结查询
function findActivityConclusionById(id) {
  let fd = new FormData()
  // fd.append("token", token)
  fd.append("activityId", id)
  return request({
    url: "/djyl/admin/activity/info/findActivityConclusionById",
    method: "POST",
    data: fd
  });

}
//获取最美字段
function findPartyReportKeywords() {

  return request({
    url: "/djyl/admin/partyReport/info/findPartyReportKeywords",
    method: "POST",
    data: {}
  });
}

function findActivityConclusionList({
                                      pageNo,
                                      pageSize,
                                      activityId
                                    }) {
  let fd = new FormData()
  // fd.append("token", token)
  fd.append("pageNo", pageNo)
  fd.append("pageSize", pageSize)

  fd.append("activityId", activityId)


  return request({
    url: "/djyl/admin/activity/info/findActivityConclusionList",
    method: "POST",
    data: fd
  });
}

//志愿服务获取志愿信息
function getZyfwInfor(val) {
  return request({
    url: "/djyl/admin/activity/info/volunteerStatistics",
    method: "POST",
  });
}
export {
  insertPartyReport,
  findPartyReport,
  findPartyReportById,
  updatePartyReport,
  deletePartyReport,
  auditPartyReport,
  insertActivity,
  findPartyReportStatistics,
  findPartyReportMothStatistics,
  findActivity,
  findActivityById,
  updateActivity,
  auditActivity,
  deleteActivity,
  stopActivity,
  uploadOnlineStudyPhoto,
  uploadOnlineStudyVideo,
  uploadOnlineStudyAudio,
  insertOnlineStudy,
  findOnlineStudy,
  deleteOnlineStudy,
  findOnlineStudyById,
  updateOnlineStudy,
  auditOnlineStudy,
  stopOnlineStudy,
  findResourceTypeStatistic,
  findOnlineStudyRanking,
  uploadQuestionBankPhoto,
  insertQuestionBank,
  findQuestionBank,
  findQuestionBankById,
  findOnlineStudyStatistic,
  findStudyPersonStatistic,
  findStudyAgeStatistic,
  updateQuestionBank,
  auditQuestionBank,
  deleteQuestionBank,
  findTopicTypeStatistic,
  findKnowledgeStatistic,
  findCoefficientStatistic,
  chooseTestPerson,
  insertTestPaper,
  findQuestion,
  findTestPaper,
  findTestPaperById,
  publishedPapers,
  deleteTestPaper,
  invalidTest,
  endTest,
  findTestPaperByIds,
  updateTestPaper,
  auditTestPaper,
  findGroupWayStatistics,
  findTestNumberStatistics,
  findScore,
  findScorePage,
  findScoreById,
  findPassTestStatistics,
  findTestPersonStatistics,
  findTestOrgStatistics,
  findPartyScore,
  findPassRateStatistics,
  findOrgAverageStatistics,
  findGoodPartyStatistics,
  findPartyIntegral,
  findPartyIntegralOrg,
  findPartyIntegralRank,
  findPartyIntegralSource,
  insertPartyOrganization,
  findPartyOrganization,
  findPartyOrganizationById,
  applyJoinParty,
  activistsParty,
  developParty,
  prepareParty,
  positiveParty,
  findPartyOrganizationNumber,
  findPartyOrganizationDevelop,
  findPartyOrganizationStructure,
  findActivitySignUpById,
  findActivitySignUp,
  auditSignUp,
  batchAuditSignUp,
  findActivityConclusionById,
  findActivityConclusionList,
  findPartyReportKeywords,
  findKeywords,
  getZyfwInfor
}